// Flight Search Constants and Configurations

export const TRIP_TYPES = ['Round-trip', 'One-way', 'Multi-city'];

export const CABIN_CLASSES = ['Economy', 'Premium Economy', 'Business', 'First'];

export const PASSENGER_TYPES = [
  {
    key: 'adults',
    label: 'Adults',
    subtitle: '18-64',
    min: 1,
    max: 9
  },
  {
    key: 'students',
    label: 'Students',
    subtitle: 'over 18',
    min: 0,
    max: 9
  },
  {
    key: 'seniors',
    label: 'Seniors',
    subtitle: 'over 65',
    min: 0,
    max: 9
  },
  {
    key: 'youths',
    label: 'Youths',
    subtitle: '12-17',
    min: 0,
    max: 9
  },
  {
    key: 'children',
    label: 'Children',
    subtitle: '2-11',
    min: 0,
    max: 9
  },
  {
    key: 'toddlers',
    label: 'Toddlers in own seat',
    subtitle: 'under 2',
    min: 0,
    max: 9
  },
  {
    key: 'infants',
    label: 'Infants on lap',
    subtitle: 'under 2',
    min: 0,
    max: 9
  }
];

export const DEFAULT_INITIAL_VALUES = {
  initialFrom: ["London (LON)"],
  initialTo: [], 
  initialDepartureDate: "",
  initialReturnDate: "",
  initialAdults: 1,
  initialStudents: 0,
  initialSeniors: 0,
  initialYouths: 0,
  initialChildren: 0,
  initialToddlers: 0,
  initialInfants: 0,
  initialTripType: "Round-trip",
  initialCabin: "Economy",
  initialBags: 0,
  buttonLabel: "Search"
}; 